import React, { SVGProps } from "react";

const MenuDotsOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66667 8.00008C4.66667 8.3537 4.52619 8.69284 4.27614 8.94289C4.02609 9.19294 3.68696 9.33342 3.33333 9.33342C2.97971 9.33342 2.64057 9.19294 2.39052 8.94289C2.14048 8.69284 2 8.3537 2 8.00008C2 7.64646 2.14048 7.30732 2.39052 7.05727C2.64057 6.80722 2.97971 6.66675 3.33333 6.66675C3.68696 6.66675 4.02609 6.80722 4.27614 7.05727C4.52619 7.30732 4.66667 7.64646 4.66667 8.00008ZM14 8.00008C14 8.3537 13.8595 8.69284 13.6095 8.94289C13.3594 9.19294 13.0203 9.33342 12.6667 9.33342C12.313 9.33342 11.9739 9.19294 11.7239 8.94289C11.4738 8.69284 11.3333 8.3537 11.3333 8.00008C11.3333 7.64646 11.4738 7.30732 11.7239 7.05727C11.9739 6.80722 12.313 6.66675 12.6667 6.66675C13.0203 6.66675 13.3594 6.80722 13.6095 7.05727C13.8595 7.30732 14 7.64646 14 8.00008Z"
      fill="black"
    />
    <path
      opacity="0.5"
      d="M9.33317 8.00008C9.33317 8.3537 9.19269 8.69284 8.94265 8.94289C8.6926 9.19294 8.35346 9.33342 7.99984 9.33342C7.64622 9.33342 7.30708 9.19294 7.05703 8.94289C6.80698 8.69284 6.6665 8.3537 6.6665 8.00008C6.6665 7.64646 6.80698 7.30732 7.05703 7.05727C7.30708 6.80722 7.64622 6.66675 7.99984 6.66675C8.35346 6.66675 8.6926 6.80722 8.94265 7.05727C9.19269 7.30732 9.33317 7.64646 9.33317 8.00008Z"
      fill="black"
    />
  </svg>
);

export default MenuDotsOutline;
